/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrOrgAuthProvider } from './irrOrgAuthProvider';


export interface IrrOAuthApp { 
    authProvider?: IrrOrgAuthProvider;
    clientId?: string;
    clientLocation?: string;
    clientTimestamp?: string;
    defaultRedirectUri?: string;
    redirectUris?: Array<string>;
}
export namespace IrrOAuthApp {
}


